import { deserialize, inheritSerialization } from 'cerialize';
import { Entity } from './entity';

@inheritSerialization(Entity)
export class Actualite extends Entity {

  @deserialize
  titre: string = null;

  @deserialize
  images: any[] = [];

  @deserialize
  contenu: string = null;

  @deserialize
  date: Date = null;

  @deserialize
  type: string = null;
}
